skrilla.service('adminV2Service', function (envService, queryService, $window) {

    let openV2 = function (path, query) {
        path = path || "users"
        query = query === undefined ? {} : query
        let request = {
            token: $window.localStorage.token.replace("Bearer ", ""),
            redirect: `${path}${encodeURIComponent(queryService.getQueryString(query))}`
        }
        let url = `${envService.read("v2Url")}/injest${queryService.getQueryString(request)}`
        window.open(url, "_blank");
    }

    return {
        openV2,
    };
});

